import SessionToken from 'models/BioId/SessionToken';

type Header = {
  authorization : string;
};

type RequestOptions = {
  headers : Header;
};

async function fetchSessionToken() : Promise<void> {
  new Promise<void>((resolve) => {
    // eslint-disable-next-line
    // @ts-ignore
    window.BIOBAR_SESSION = (response) : void => {
      window.localStorage.setItem('biobar:session', JSON.stringify(response));
      document.getElementById('biobar-session-token')?.remove();
      resolve();
    };
  });

  new Promise<void>((resolve) => {
    const clientId = getClientId();
    const script = document.createElement('script');
    script.id = 'biobar-session-token';
    script.async = true;
    script.type = 'text/javascript';
    script.src = `${process.env.REACT_APP_BIOID_BASE_URL}/biobar/session_token?application=${clientId}&callback=window.BIOBAR_SESSION`;
    document.getElementsByTagName('head')[0].appendChild(script);

    script.onload = () : void => {
      resolve();
    };
  });
}

function getClientId() : string {
  const clientId = 'biobar';
  try {
    return window.localStorage.getItem('biobar:client_id') || clientId;
  } catch {
    return clientId;
  }
}

export function getToken() : SessionToken {
  try {
    return JSON.parse(window.localStorage.getItem('biobar:session') || '');
  } catch {
    return {} as SessionToken;
  }
}

export function getAuthorizationToken() : RequestOptions {
  fetchSessionToken();
  return { headers : { 'authorization': `Bearer ${getToken().token}` }};
}

export default fetchSessionToken;